import { render, staticRenderFns } from "./BaseSelectList.vue?vue&type=template&id=6624d7d6&scoped=true&"
import script from "./BaseSelectList.vue?vue&type=script&lang=js&"
export * from "./BaseSelectList.vue?vue&type=script&lang=js&"
import style0 from "./BaseSelectList.vue?vue&type=style&index=0&id=6624d7d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6624d7d6",
  null
  
)

export default component.exports